"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sms__or__text(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "06b9cabd-d8cd-4a86-b9f5-8f43e957c23f",
    "data-name": "Text_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,109.75",
    fill: "none",
    stroke: "#fecb00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,110H60.24L37.88,134V110H32A14,14,0,0,1,18,96V56A14,14,0,0,1,32,42h72a14,14,0,0,1,14,14V78",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,150l24.12,24V150H160a14,14,0,0,0,14-14V92a14,14,0,0,0-14-14H88A14,14,0,0,0,74,92v44a14,14,0,0,0,14,14Z",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "a9f0c6d9-1e36-437c-a8c1-8abca19b76a9",
    "data-name": "<Pfad>",
    x1: 150,
    y1: 102,
    x2: 98,
    y2: 102,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "8af5a606-adb1-40bc-bae0-e3ba7e8c1d8f",
    "data-name": "<Pfad>",
    x1: 150,
    y1: 126,
    x2: 98,
    y2: 126,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("title", null, "sms-mid"), /*#__PURE__*/React.createElement("g", {
    id: "0cee4856-7b2e-45b0-a3e7-35573b6bf389",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    id: "b293e255-83bc-4cc7-ada3-75846d6dff5e",
    "data-name": "Text_ic_mid",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#06b9cabd-d8cd-4a86-b9f5-8f43e957c23f"
  })));
}

var _default = ic_sms__or__text;
exports.default = _default;